import React from "react";

export default function Headerteam() {
  return (
    <div className="trt-hero">
      <div className="trt-hero-deco"></div>
      <div className="trt-hero-deco2"></div>
      <div className="trt-hero-content">
        <div className="trt-hero-title">
          Halo, {localStorage.getItem("nama")} 👋
        </div>
        <div className="trt-hero-subtitle">
          Kelola tim dan pemain anda di Rank Team
        </div>
      </div>
    </div>
  );
}
